/* KsG：クリック計測（統合版 2026-10-03）— assets/ksg-link-tracking.js
 *
 * 施策ログ id=62（商品リンクのクリック）と id=66（ハンバーガーメニュー）を1本にまとめたもの。
 * 読み込み：layout/theme.liquid の </body> の直前に
 *   <script src="{{ 'ksg-link-tracking.js' | asset_url }}" defer></script>
 *
 * 送るイベント（テーマ → Shopify.analytics.publish → カスタムピクセル web-pixel-163709164 rev3 → GA4）
 *   select_item  … ①商品リンク（/products/）を押した：item_list_id = セクションの種類
 *                  ②メニュー内のリンクを押した：item_list_id = 'menu'
 *                  🔴 メニューの中のクリックは②だけで送る（①では数えない）＝二重にならない
 *   menu_open    … ドロワーを開いた（menu_panel = 'main'）／サブパネルを開いた（menu_panel = 親の項目名）
 *                  「開いた回数」は menu_panel = 'main' だけで数える
 *   menu_scroll  … メニューのパネル内スクロール 25 / 50 / 75 / 100%（開くたびに各1回）
 *
 * 決まり
 *   - gtag は直接呼ばない（ページの window.gtag は別のタグの可能性がある）。送るのは Shopify.analytics.publish だけ
 *   - view_item_list・page_view は送らない（既存の計測と混ざらないように）
 *   - preventDefault を使わない（遷移を止めない）。すべて try/catch で包む
 *   - 同じ名前で clarity('event', …) も送る（Clarity の録画をイベントで絞り込むため）
 *   - 送るのはリンクの文字・リンク先・位置だけ。顧客情報は送らない
 */
(function () {
  'use strict';

  if (window.__ksgLinkTracking) return;
  window.__ksgLinkTracking = true;

  /* ================= 共通 ================= */

  function publish(name, payload) {
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') a.publish(name, payload);
    } catch (e) { /* 計測で画面を壊さない */ }
    try {
      if (typeof window.clarity === 'function') window.clarity('event', name);
    } catch (e) { /* 同上 */ }
  }

  function text(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim().slice(0, 80);
  }

  function pathOf(a) {
    try {
      var u = new URL(a.getAttribute('href'), location.href);
      return u.host === location.host ? u.pathname : u.href;
    } catch (e) {
      return a.getAttribute('href') || '';
    }
  }

  function indexIn(list, el) {
    return Array.prototype.indexOf.call(list, el) + 1;
  }

  function pageKind() {
    var p = location.pathname;
    if (/^\/products\//.test(p)) return 'product';
    if (/^\/collections\/[^/]+\/products\//.test(p)) return 'product';
    if (/^\/collections\//.test(p)) return 'collection';
    if (/^\/cart/.test(p)) return 'cart';
    if (p === '/') return 'top';
    if (/^\/search/.test(p)) return 'search';
    return 'other';
  }

  function sidebar() {
    return document.getElementById('sidebar-menu');
  }

  /* ================= ① 商品リンク（id=62） ================= */

  // セクションの種類（class="shopify-section shopify-section--<type>"）→ item_list_id
  var MAP = {
    'custom-related-products':  'coordinate_product',  // 一緒にコーディネートされたアイテム
    'cart-related-products':    'coordinate_cart',     // 同じ（カートページ）
    'related-products':         'recommend_auto',      // 関連アイテム（自動レコメンド）
    'recently-viewed-products': 'recently_viewed',     // 最近チェックした
    'purchased-with':           'purchased_with',
    'featured-collections':     'featured_collection', // トップの商品枠・商品ページのランキング枠
    'featured-product-videos':  'video_section',
    'main-product':             'main_product',        // 本文内（complementary など）
    'main-collection':          'collection_grid',     // コレクションの商品一覧
    'cart-drawer':              'cart_drawer',
    'main-search':              'search_results',
    'main-cart':                'cart_page',
    'header':                   'header',
    'carousel':                 'top_slide'
  };

  // セクションID（template--…__featured_collections_LYJjEQ）の末尾。同じ種類の枠を見分ける
  function sectionKey(sec) {
    var id = (sec && sec.id) || '';
    return id.indexOf('__') >= 0 ? id.split('__').pop() : id.replace(/^shopify-section-/, '');
  }

  function listId(a) {
    if (a.closest('[class*="complementary-products"]')) return 'complementary';
    if (a.closest('[class*="coordinates"]')) return 'coordinate_video';
    // 検索の入力中候補（後から JS で描かれる。ヘッダーのセクションの中にある）
    if (a.closest('predictive-search, .predictive-search')) return 'search_suggest';

    var sec = a.closest('.shopify-section');
    if (sec) {
      var m = (sec.className || '').match(/shopify-section--([a-z0-9-]+)/);
      if (m) return MAP[m[1]] || ('section_' + m[1]);
      // クラスに種類が出ないセクション（トップの carousel など）は ID から
      var k = sectionKey(sec).replace(/_[A-Za-z0-9]{6}$/, '').replace(/_/g, '-');
      if (k) return MAP[k] || ('section_' + k);
    }
    if (a.closest('header')) return 'header';
    if (a.closest('footer')) return 'footer';
    return 'unknown';
  }

  function handleOf(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // 同じ枠の中で何番目の商品か（画像と商品名が別リンクでも1商品として数える）
  function productIndex(a, h) {
    var scope = a.closest('.shopify-section') || a.closest('predictive-search') || document.body;
    var seen = [];
    Array.prototype.forEach.call(scope.querySelectorAll('a[href*="/products/"]'), function (x) {
      var hx = handleOf(x.getAttribute('href'));
      if (hx && seen.indexOf(hx) < 0) seen.push(hx);
    });
    return seen.indexOf(h) + 1;
  }

  function onProductClick(a) {
    var h = handleOf(a.getAttribute('href'));
    if (!h) return;
    if (a.getAttribute('aria-current') === 'page') return; // パンくずの現在ページなど
    var id = listId(a);
    var sec = a.closest('.shopify-section');
    var img = a.querySelector('img[alt]');
    var name = text(a) || (img && img.getAttribute('alt').trim().slice(0, 80)) || h;  // 画像だけのリンクは alt
    var idx = productIndex(a, h);
    publish('select_item', {
      item_list_id: id,
      item_list_name: id,
      section_key: sectionKey(sec),
      page_kind: pageKind(),
      link_url: pathOf(a),
      items: [{
        item_id: h,          // ハンドル（商品IDが取れない要素もあるため）
        item_name: name,
        item_list_id: id,
        item_list_name: id,
        index: idx
      }]
    });
  }

  /* ================= ② ハンバーガーメニュー（id=66） ================= */

  var MENU_ID = 'menu';
  var MENU_NAME = 'ハンバーガーメニュー';
  var DEPTHS = [25, 50, 75, 100];
  var openSeq = 0;     // そのページで何回目に開いたか
  var sentDepth = {};  // { パネル名: { 25: true, … } } 開くたびにリセット

  function topItems(sb) {
    return sb.querySelectorAll('.header-sidebar__main-panel .header-sidebar__linklist > li > .header-sidebar__linklist-button');
  }

  function parentButtonOf(sb, subPanel) {
    return subPanel && subPanel.id ? sb.querySelector('[aria-controls="' + subPanel.id + '"]') : null;
  }

  function describe(sb, a) {
    var head = a.closest('.sidebar-menu__header');
    if (head) return { level: 'shortcut', parent: '', index: indexIn(head.querySelectorAll('a'), a), top: 0 };
    var sub = a.closest('.header-sidebar__sub-panel');
    if (sub) {
      var btn = parentButtonOf(sb, sub);
      return {
        level: a.closest('.header-sidebar__nested-linklist') ? 'grandchild' : 'child',
        parent: text(btn),
        index: indexIn(sub.querySelectorAll('.header-sidebar__linklist-button, .header-sidebar__nested-linklist a'), a),
        top: btn ? indexIn(topItems(sb), btn) : 0
      };
    }
    if (a.closest('.header-sidebar__footer')) return { level: 'footer', parent: '', index: 0, top: 0 };
    var ti = indexIn(topItems(sb), a);
    return { level: 'top', parent: '', index: ti, top: ti };
  }

  function onMenuClick(sb, target) {
    // サブパネルを開くボタン（トップス ▸ など）
    var btn = target.closest('.header-sidebar__main-panel button[aria-controls^="header-panel-"]');
    if (btn) {
      publish('menu_open', {
        menu_panel: text(btn),
        menu_top_index: indexIn(topItems(sb), btn),
        menu_open_seq: openSeq,
        item_list_id: MENU_ID
      });
      return;
    }
    var a = target.closest('a[href]');
    if (!a) return;
    var d = describe(sb, a);
    var path = pathOf(a);
    var name = text(a);
    publish('select_item', {
      item_list_id: MENU_ID,
      item_list_name: MENU_NAME,
      menu_level: d.level,        // shortcut / top / child / grandchild / footer
      menu_parent: d.parent,      // 子なら親の項目名
      menu_index: d.index,        // パネル内で上から何番目か（1始まり）
      menu_top_index: d.top,      // トップ階層での位置（子は親の位置）
      menu_open_seq: openSeq,
      page_kind: pageKind(),
      link_url: path,
      link_text: name,
      items: [{
        item_id: path,
        item_name: name,
        item_list_id: MENU_ID,
        item_list_name: MENU_NAME,
        item_category: d.parent || '(top)',
        index: d.index
      }]
    });
  }

  function panelName(sb, scroller) {
    if (scroller.closest('.header-sidebar__collapsible-panel')) {
      var sub = sb.querySelector('.header-sidebar__sub-panel:not([hidden])');
      return text(parentButtonOf(sb, sub)) || 'sub';
    }
    return 'main';
  }

  function bindScrollers(sb) {
    try {
      Array.prototype.forEach.call(sb.querySelectorAll('.header-sidebar__scroller'), function (sc) {
        if (sc.__ksgBound) return;
        sc.__ksgBound = true;
        var ticking = false;
        sc.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            try {
              var range = sc.scrollHeight - sc.clientHeight;
              if (range <= 4) return; // スクロールできないパネルは送らない
              var pct = Math.min(100, Math.round(100 * sc.scrollTop / range));
              var panel = panelName(sb, sc);
              var done = sentDepth[panel] || (sentDepth[panel] = {});
              DEPTHS.forEach(function (t) {
                if (pct >= t && !done[t]) {
                  done[t] = true;
                  publish('menu_scroll', {
                    menu_panel: panel,
                    percent_scrolled: t,
                    menu_open_seq: openSeq,
                    item_list_id: MENU_ID
                  });
                }
              });
            } catch (e) { /* 同上 */ }
          });
        }, { passive: true });
      });
    } catch (e) { /* 同上 */ }
  }

  function watchMenu() {
    try {
      var sb = sidebar();
      if (!sb) return;
      var wasOpen = sb.hasAttribute('open');
      new MutationObserver(function () {
        try {
          var isOpen = sb.hasAttribute('open');
          if (isOpen && !wasOpen) {
            openSeq += 1;
            sentDepth = {};
            publish('menu_open', { menu_panel: 'main', menu_open_seq: openSeq, item_list_id: MENU_ID });
            bindScrollers(sb);
          }
          wasOpen = isOpen;
        } catch (e) { /* 同上 */ }
      }).observe(sb, { attributes: true, attributeFilter: ['open'] });
      bindScrollers(sb);
    } catch (e) { /* 同上 */ }
  }

  /* ================= クリックの受け口（1か所） ================= */

  document.addEventListener('click', function (ev) {
    try {
      var t = ev.target;
      if (!t || !t.closest) return;
      var sb = sidebar();
      // 🔴 メニューの中は②だけ。商品リンクがあっても①では送らない
      if (sb && sb.contains(t)) {
        onMenuClick(sb, t);
        return;
      }
      var a = t.closest('a[href*="/products/"]');
      if (a) onProductClick(a);
    } catch (e) { /* 遷移は止めない */ }
  }, true); // capture：遷移の前に確実に走らせる

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchMenu);
  } else {
    watchMenu();
  }
})();
